import { jsx } from 'react/jsx-runtime';
import cx from 'clsx';
import { s as styles } from './styles.module-C8v7Qt7u.js';

const MenuItem = ({ children, className, contentClassName, isActive, isDisabled, value, onClick, }) => {
    const onMenuItemClick = () => {
        if (isDisabled)
            return;
        onClick?.(value);
    };
    return (jsx("li", { className: cx(styles.containerRoot, className, {
            [styles.isActive]: isActive,
            [styles.isDisabled]: isDisabled,
        }), children: jsx("div", { className: cx(styles.textContent, contentClassName), role: "button", tabIndex: isDisabled ? -1 : 0, onClick: onMenuItemClick, onKeyDown: onMenuItemClick, children: children }) }));
};

export { MenuItem as M };
//# sourceMappingURL=component-BcM2NOEt.js.map
